// Copyright 2025-2026 - Hewlett Packard Enterprise Company
import React from 'react';
import { Box, Card, Text } from 'grommet';
import PropTypes from 'prop-types';
import { User } from '@hpe-design/icons-grommet/icons/User';

const ChatQuery = ({ query }) => (
  <Box
    width={{ max: '100%' }}
    direction="column"
    margin={{ bottom: 'medium', left: '3xsmall' }}
  >
    <Box direction="row" justify="end" align="center" flex>
      {query !== undefined && (
        <>
          <Card
            data-testid="chat-user-query"
            direction="row"
            pad={{ horizontal: 'small', vertical: 'xsmall' }}
            fill
            margin={{ left: 'xlarge' }}
            style={{
              wordBreak: 'break-word',
            }}
          >
            <Text data-testid="chat-user-query-text">{query}</Text>
          </Card>
          <Box margin={{ left: 'xsmall', right: 'xsmall' }}>
            <User color="text-strong" />
          </Box>
        </>
      )}
    </Box>
  </Box>
);

export default ChatQuery;

ChatQuery.propTypes = {
  query: PropTypes.string.isRequired,
};
